import { useState } from 'react';
import { type DonViCoSo, type KhachHang, type TaiKhoan } from '@/types/schemas';

export interface SearchFieldState {
  taiKhoanCo: TaiKhoan | null;
  khachHang: KhachHang | null;
  taikhoanNo: TaiKhoan | null;
  donVi: DonViCoSo | null;
}

export interface SearchFieldActions {
  setTaiKhoanCo: (taiKhoanCo: TaiKhoan | null) => void;
  setKhachHang: (khachHang: KhachHang | null) => void;
  setTaiKhoanNo: (taikhoanNo: TaiKhoan | null) => void;
  setDonVi: (donVi: DonViCoSo | null) => void;

  // Utility functions
  resetState: () => void;
  updateState: (updates: Partial<SearchFieldState>) => void;
}

export interface UseSearchFieldStateReturn {
  state: SearchFieldState;
  actions: SearchFieldActions;
}

const initialState: SearchFieldState = {
  taiKhoanCo: null,
  khachHang: null,
  taikhoanNo: null,
  donVi: null
};

export function useSearchFieldStates(): UseSearchFieldStateReturn {
  const [state, setState] = useState<SearchFieldState>(initialState);

  const actions: SearchFieldActions = {
    setTaiKhoanCo: (taiKhoanCo: TaiKhoan | null) => {
      setState(prev => ({ ...prev, taiKhoanCo }));
    },

    setKhachHang: (khachHang: KhachHang | null) => {
      setState(prev => ({ ...prev, khachHang }));
    },

    setTaiKhoanNo: (taikhoanNo: TaiKhoan | null) => {
      setState(prev => ({ ...prev, taikhoanNo }));
    },

    setDonVi: (donVi: DonViCoSo | null) => {
      setState(prev => ({ ...prev, donVi }));
    },

    resetState: () => {
      setState(initialState);
    },

    updateState: (updates: Partial<SearchFieldState>) => {
      setState(prev => ({ ...prev, ...updates }));
    }
  };

  return { state, actions };
}
